<template>
  <div id="xuliehaoadd">
    <div class="tableheader">
      <el-button @click="getList(1)" class="btn3" type="primary">{{$t("search")}}</el-button>
      <el-input v-model="code" class="codeshearch" size="small" :placeholder="$i18n.t('xunliemaask').searchkey"></el-input>
	  <el-button @click="showAsk()" class="btn3 toask" type="primary">{{$t("xunliemaask").control[1]}}</el-button>
    </div>
    <div class="deviceAddBlock">
      <el-table :data="lists" style="width: 100%">
        <el-table-column prop="name" :label="$i18n.t('xunliemaask').tablefiled[0]" width="170"></el-table-column>
        <el-table-column prop="num" :label="$i18n.t('xunliemaask').tablefiled[1]" width="170"></el-table-column>
        <el-table-column prop="crt_time" :label="$i18n.t('xunliemaask').tablefiled[4]" width="180"></el-table-column>
        <el-table-column prop="opt_user" :label="$i18n.t('xunliemaask').tablefiled[5]" width="100"></el-table-column>
        <el-table-column :label="$i18n.t('xunliemaask').tablefiled[2]" width="150">
			<template slot-scope="scope">
			  <span v-if="scope.row.status==10" style="color: green;">{{$t('xunliemaask').status[1]}}</span>
			  <span v-else-if="scope.row.status==11" style="color: red;">{{$t('xunliemaask').status[2]}}</span>
			  <span v-else-if="scope.row.status==-10" style="color: black;">{{$t('xunliemaask').status[3]}}</span>
			  <span style="color: #fc5531;" v-else>{{$t('xunliemaask').status[0]}}</span>
			</template>
		</el-table-column>
        <el-table-column prop="reason" :label="$i18n.t('xunliemaask').tablefiled[3]" width="180"></el-table-column>
        <el-table-column prop="approve_time" :label="$i18n.t('xunliemaask').tablefiled[6]" width="180"></el-table-column>
		<el-table-column :label="$i18n.t('xunliemaask').tablefiled[7]">
			<template slot-scope="scope">
				<el-button v-if="scope.row.status==0" @click="cancleAsk(scope.row.id)" class="btn2" type="primary" size="mini">{{$t("xunliemaask").control[0]}}</el-button>
				<el-link type="primary" :href="'/skinMgrSrv/device/serialExport?id='+scope.row.batch_id" v-if="scope.row.status==10" target="_blank">{{$t("xunliemaask").control[2]}}</el-link>
				<span v-if="scope.row.status==-10" style="color: black;">{{$t('xunliemaask').status[3]}}</span>
			</template>
		</el-table-column>
      </el-table>
	  <el-pagination @current-change="getList" style="margin-top: 0.2rem;" background layout="prev, pager, next" :total="total" :page-size="pageSize" :current-page.sync="pageNo"> </el-pagination>
    </div>
	<el-dialog width="25%" :title="$i18n.t('xunliemaask').form.title" :visible.sync="dialogFormVisible">
	  <el-form :model="form">
	    <el-form-item :label="$i18n.t('xunliemaask').form.name" :label-width="formLabelWidth">
	      <el-input v-model="form.name" autocomplete="off"></el-input>
	    </el-form-item>
	    <el-form-item :label="$i18n.t('xunliemaask').form.num" :label-width="formLabelWidth">
	      <el-input v-model="form.num" autocomplete="off"></el-input>
	    </el-form-item>
	  </el-form>
	  <div slot="footer" class="dialog-footer">
	    <el-button @click="dialogFormVisible = false">{{$t('xunliemaask').form.cancle}}</el-button>
	    <el-button type="primary" @click="toAsk()">{{$t('xunliemaask').form.sure}}</el-button>
	  </div>
	</el-dialog>
  </div>
</template>

<script>
export default {
  name: 'xuliehaoadd',
  data () {
    return {
      doing: false,
      code: '',
      lists: null,
      dialogVisible: false,
      info: {},
	  total: 0,
	  pageSize: 15,
	  pageNo: 1,
	  dialogFormVisible: false,
	  formLabelWidth: '100px',
	  form: {
		name: '',
		num: 100
	  }
    }
  },
  computed: {
    
  },
  created () {
    this.getList(1)
  },
  methods: {
    getList (val) {
      if (this.doing === true) {
        return false
      }
      let dataLoadIng = this.openFullScreen()
      this.doing = true
      let _this = this
	  _this.pageNo = val
      let data = {search: this.code, pageSize: this.pageSize, pageNo: this.pageNo}
      this.axios.post('/skinMgrSrv/device/serialAskList', this.formData(data)).then(function (response) {
        _this.doing = false
        if (response.data.code === 0) {
			_this.lists = response.data.list
			_this.total = parseInt(response.data.total)
        }
        setTimeout(() => {
          dataLoadIng.close()
        }, 500);
      })
    },
    cancleAsk (id) {
      this.doing = true
      let _this = this
      let data = {id: id}
      this.axios.post('/skinMgrSrv/device/serialCancleAsk', this.formData(data)).then(function (response) {
        _this.doing = false
        if (response.data.code === 0) {
        	_this.$message(_this.$i18n.t('xunliemaask').tips[2])
        	_this.getList(_this.pageNo)
        }else{
        	_this.$message(_this.$i18n.t('xunliemaask').tips[3])
        }
      })
    },
	showAsk(){
		this.form = {name: '',num: ''}
		this.dialogFormVisible = true
	},
    toAsk () {
      //申请授权码
	  if(this.form.name == ''){
		this.$message(this.$i18n.t('xunliemaask').warns[0])
		return false
	  }
	  if(isNaN(this.form.num)){
		this.$message(this.$i18n.t('xunliemaask').warns[2])
		return false
	  }
	  if(this.form.num < 100){
		this.$message(this.$i18n.t('xunliemaask').warns[1])
		return false
	  }
	  this.doing = true
	  let _this = this
	  let userinfo = JSON.parse(sessionStorage.userInfo)
	  let data = {name: this.form.name, num: this.form.num, opt_user: userinfo.user_acct}
	  this.axios.post('/skinMgrSrv/device/serialAsk', this.formData(data)).then(function (response) {
	    _this.doing = false
	    if (response.data.code === 0) {
			_this.dialogFormVisible = false
			_this.$message(_this.$i18n.t('xunliemaask').tips[0])
	  		_this.getList(_this.pageNo)
	    }else{
			_this.$message(_this.$i18n.t('xunliemaask').tips[1])
		}
	  })
    }
  }
}
</script>
<style  lang="scss">
  #xuliehaoadd{
    .tabs-container {
      .el-card__header {padding: 0.0833rem 0.1667rem !important;}
      .el-card{cursor: pointer;}
      .el-card:hover{border: $blue 1px solid;}
    }
    .el-dialog__header{border-bottom: #E9E9E9 1px solid !important;}
    .el-button--mini, .el-button--mini.is-round {padding: 7px 0.0833rem;}
    .el-button--primary {color: #fff;background-color: #57AEC9;border-color: #57AEC9;}
    .el-radio-button__orig-radio:checked+.el-radio-button__inner {color: #fff;background-color: #57AEC9;border-color: #57AEC9;-webkit-box-shadow: -1px 0 0 0 #57AEC9;box-shadow: -1px 0 0 0 #57AEC9;}
	.el-table th>.cell {text-align: center;}
	.el-table .cell {text-align: center;}
  }
</style>

<style scoped lang="scss">
  #xuliehaoadd {padding: 0.1667rem;box-sizing: border-box;background-color: #fff;border-radius: 0.04166rem;margin: 0.1667rem;
    p.title{height: 0.4167rem;line-height:0.4167rem;font-size:0.15rem;color:#000;}
    .btn2,.btn3{padding: 0.0667rem 0.0833rem;}
    .codeshearch{width: 1.667rem;margin-right: 0.1rem;}
    .btn3,.codeshearch{float: right;}
    .deviceAddBlock{text-align: center;margin-top: 0.0833rem;}
    .warncolor{color: red;}
    .greencolor{color: green;}
	.toask{float: left;}
  }
</style>



// WEBPACK FOOTER //
// src/device/xuliemaadd.vue